<template>
  <!-- 机台列表 -->
  <div class="rzy-page">
    <el-button type="primary" size="mini" @click="$refs.machineAdd.show()"
      >机台添加</el-button
    >
    <!-- <el-button type="danger" @click="machineDel()">批量删除选定机台</el-button> -->
    <el-table
      :data="machineList"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center', padding: '0px' }"
      border
      stripe
    >
      number: { value: "机台编号", width: "200", }, machineKind: { value:
      "机台归类", width: "200", }, workshop: { value: "所在车间", width: "200",
      }, warpKnittingMachineAxialLength: { value: "轴长(米)", width: "200", },
      warpKnittingMachineMaxComb: { value: "面梳(个)", width: "200", },
      machineType: { value: "机台类型", width: "300", },
      <el-table-column label="机台编号" prop="number" width="200" />
      <el-table-column label="机台归类" width="200">
        <template slot-scope="scope">
          {{ scope.row.machineKind == 0 ? "经编机" : "整经机" }}
        </template>
      </el-table-column>
      <el-table-column label="所在车间" prop="workshop" width="200" />
      <el-table-column
        label="轴长(米)"
        prop="warpKnittingMachineAxialLength"
        width="200"
      />
      <el-table-column
        label="面梳(个)"
        prop="warpKnittingMachineMaxComb"
        width="200"
      />
      <el-table-column label="机台类型" prop="machineType" width="200" />
      <el-table-column label="备注" prop="remark" />
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="$refs.machineEdit.show(scope.row.id)"
            >修改</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="removeMachineById(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: center"
      background
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pageInfo.size"
      :current-page="pageInfo.page"
      :total="total"
    >
    </el-pagination>
    <!-- 添加机台弹框 -->
    <machine-add ref="machineAdd" @update="changePage(pageInfo.page)" />
    <!-- 修改机台弹框 -->
    <machine-edit ref="machineEdit" @update="changePage(pageInfo.page)" />
  </div>
</template>

<script>
import { MachineAdd, MachineEdit } from "./components";
import * as api from "@/api/factory/machine/list";
export default {
  components: {
    MachineAdd,
    MachineEdit,
  },
  data() {
    return {
      machineList: [],
      pageInfo: {
        page: 1,
        size: 18,
        totalPages: 1,
      },
      deleteMachines: [],
      total: 0,
      machineKeys: {
        number: {
          value: "机台编号",
          width: "200",
        },
        machineKind: {
          value: "机台归类",
          width: "200",
        },
        workshop: {
          value: "所在车间",
          width: "200",
        },
        warpKnittingMachineAxialLength: {
          value: "轴长(米)",
          width: "200",
        },
        warpKnittingMachineMaxComb: {
          value: "面梳(个)",
          width: "200",
        },
        machineType: {
          value: "机台类型",
          width: "300",
        },
      },
    };
  },
  created() {
    this.changePage(1);
  },
  methods: {
    // 属性排序
    sortChange(val) {
      if (val.column.label === "编号") this.pageInfo.properties = "number";
      else if (val.column.label === "经编机轴向长度")
        this.pageInfo.properties = "warpKnittingMachineAxialLength";
      else this.pageInfo.properties = "warpKnittingMachineMaxComb";
      this.pageInfo.direction === "DESC"
        ? (this.pageInfo.direction = "ASC")
        : (this.pageInfo.direction = "DESC");
      this.changePage();
    },
    // 删除机台逻辑，现不支持
    deleteMachine(val) {
      this.deleteMachines = val;
    },
    // 分页切换
    handleCurrentChange(newNum) {
      this.pageInfo.page = newNum;
      this.changePage(newNum);
    },
    // 删除机台逻辑，现不支持
    machineDel() {
      this.$confirm("此操作将永久删除这些机台, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.deleteMachines
          .forEach((item) => {
            const id = item.id;
            api.machineDel(id).then((res) => {
              this.$Message.success(`机台 ${item.number} 删除成功`);
              this.changePage(this.pageInfo.page);
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      });
    },
    // 分页切换
    changePage(val) {
      this.pageInfo.page = val;
      const params = this.pageInfo;
      api.changePage(params).then((res) => {
        this.machineList = res.data.list;
        this.total = res.data.total;
      });
    },
    // 删除机台，现不支持
    removeMachineById(row) {
      console.log(row);
      const params = {
        machineId: row.id,
      };
      this.$confirm(
        "此操作将永久删除该机台, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        },
        true
      ).then(() => {
        api.removeMachineById(params).then((res) => {
          this.$Message.success(`机台 ${row.number} 删除成功`);
          this.changePage(this.pageInfo.page);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
